export function normalizeId(id: string | { _value: string }): string {
    if (!id) return null;
    if (typeof id === 'object') {
        return id._value || null;
    }
    return id || null;
}